const KeenSlider = window.KeenSlider

const { setInitialised } = window.BAO.Carousel.plugins

class MobileMenuCarousel extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['slides', 'slide']
  }

  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()

    document.addEventListener('drawerOpen', e => {
      if (e.detail.key === 'mobile') {
        if (this.carousel) this.carousel.destroy()
        this.carousel = this.setupCarousel()
      }
    })

    window.addEventListener('resize', () => {
      if (this.carousel) this.carousel.destroy()
      this.carousel = this.setupCarousel()
    })

    document.addEventListener('DOMContentLoaded', () => {
      if (this.carousel) this.carousel.destroy()
      this.carousel = this.setupCarousel()
    })
  }

  setupCarousel () {
    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: false,
        mode: 'snap',
        slides: {
          perView: 2.2,
          spacing: 10,
        },
      },
      [setInitialised()],
    )
  }
}

if (!customElements.get('mobile-menu-carousel')) {
  customElements.define('mobile-menu-carousel', MobileMenuCarousel)
}
